import { Box, Button, Typography, useTheme } from '@mui/material';
import useStyles from './styles';
import { useHistory } from 'react-router-dom';
import ErrorIcon from '@mui/icons-material/Error';

type ErrorProps = {
  message: string;
};

const Error: React.FC<ErrorProps> = ({ message }) => {
  const theme = useTheme();
  const { classes } = useStyles();
  const history = useHistory();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap={theme.spacing(4)}
    >
      <div className={classes.errorMessageIcon}>
        <ErrorIcon fontSize="large" htmlColor={theme.palette.text.error} />
      </div>
      <Box maxWidth="600px">
        <Typography variant="h6" color="textSecondary" align="center">
          {message}
        </Typography>
      </Box>
      <Button
        color="primary"
        variant="outlined"
        onClick={() => history.goBack()}
      >
        Go back
      </Button>
    </Box>
  );
};

export default Error;
